import script from "./impersonated-user-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./impersonated-user-card.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__